function previousId( id, from, to ) {
  const aIds = id.split('_');
  
  if (aIds.length >= from ) {
    return aIds.slice( from, to ).join('_'); // Quedarse con todos menos los niveles indicados por ascendant
  } else {
    return id; // Si solo hay uno, devolverlo tal cual
  }
}

$(document).ready(function () {
    var windowWidth = $(window).width();
    if( windowWidth >= 600 ){
        $( ".accordion" ).each(function() {
            $( this ).removeClass( "accordion" ).hide();
        });
    }
/*
    if( $("#judgeme_product_reviews").css("display") == "none" ){
        $("#iguana-section-button-specs4").hide();
    }

    if( $(".jdgm-rev-widg").data("number-of-reviews") == 0 ){
        $("#iguana-section-button-specs4").hide();
    }
*/
  $("#destacados,#disponibilidad,#selections,#disponibilite,#empfehlungen,#verfuegbarkeit,#featured,#availability,#marca,#brand,#marque,#marke").addClass('open').attr('open', true);
  $("#disponible-en-boutique>div>ul>li:first").insertBefore("#disponibilidad>div>ul>li:first");
  
  var aSales = ['Rebajas', 'Sale', 'Soldes', 'Ofertas', 'Offre', 'Angebot', 'On Sale', 'Black Friday', 'Flash Sale', 'Easter Sale', 'Pen Week', 'Watch Week'];
  $.each( aSales, function( index, value ) {
//    $(".faceted-filter-group-display__list-item-label-text:contains('"+value+"')").css("color","#FFFFFF").css("background-color",'#CCEAFF');
    $(".faceted-filter-group-display__list-item-label-text:contains('"+value+"')").css("color","#FFFFFF").css("background-color","#7F949D");
/*
    $(".faceted-filter-group-display__list-item-label-text:contains('"+value+"')").css("color","#7F949D");
*/
  });
  aSales = ['Dernière Chance', 'Last Chance', 'Letzte Chance', 'Última oportunidad'];
  $.each( aSales, function( index, value ) {
    $(".faceted-filter-group-display__list-item-label-text:contains('"+value+"')").css("color","#ffffff").css("background-color","#A3322E");
  });
  
  /* 2025-04-25 Autoapertura de menú destacadas escritura, relojería */

//  $("#mobile_menu>li.sublink:first>a>span").toggleClass("active");
//  $("#mobile_menu>li.sublink:first>a>span").parent().next().slideToggle();
  
  /* Escritura */
  $("#mobile_menu>li.sublink:nth-child(2)>ul>div>li.sublink:first>a>span").toggleClass("active");
  $("#mobile_menu>li.sublink:nth-child(2)>ul>div>li.sublink:first>a>span").parent().next().slideToggle();
  $("#mobile_menu>li.sublink:nth-child(2)>a.parent-link--true").attr('href', '#').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  $("#mobile_menu>li.sublink:nth-child(2)>a.parent-link--true>span").off('click');
/*
  $("#mobile_menu>li.sublink:nth-child(2)>ul>div>li.sublink:nth-child(3)>ul>li").insertBefore("#mobile_menu>li.sublink:nth-child(2)>ul>div>li.sublink:nth-child(3)");
  $("#mobile_menu>li.sublink:nth-child(2)>ul>div>li.sublink:nth-child(4)").hide();
*/  
  /* Relojería */
  $("#mobile_menu>li.sublink:nth-child(3)>ul>div>li.sublink:first>a>span").toggleClass("active");
  $("#mobile_menu>li.sublink:nth-child(3)>ul>div>li.sublink:first>a>span").parent().next().slideToggle();
  $("#mobile_menu>li.sublink:nth-child(3)>a.parent-link--true").attr('href', '#').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  $("#mobile_menu>li.sublink:nth-child(3)>a.parent-link--true>span").off('click');
/*
  $("#mobile_menu>li.sublink:nth-child(3)>ul>div>li.sublink:nth-child(3)>ul>li").insertBefore("#mobile_menu>li.sublink:nth-child(3)>ul>div>li.sublink:nth-child(3)");
  $("#mobile_menu>li.sublink:nth-child(3)>ul>div>li.sublink:nth-child(4)").hide();
*/  
  /* Accesorios */
  $("#mobile_menu>li.sublink:nth-child(4)>a.parent-link--true").attr('href', '#').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  $("#mobile_menu>li.sublink:nth-child(4)>a.parent-link--true>span").off('click');

  /* Bucle para mover los submenús */
  var aMenus = [
    'escritura_ver-todas-las-marcas_ver-todas-las-marcas',
    'relojes_ver-todas-las-marcas_ver-todas-las-marcas',
    'accesorios_ver-todos-los-accesorios_ver-todos-los-accesorios',
    'pens_shop-all-pens_shop-all-brands',
    'watches_shop-all-watches_shop-all-brands',
    'accessories_shop-all-accessories_shop-all-accessories',
    'stylos_voir-toutes-les-marques_voir-toutes-les-marques',
    'montres_voir-toutes-les-marques_voir-toutes-les-marques',
    'accessoires_voir-tous-les-accessoires_voir-tous-les-accessoires',
    'schreibwaren_alle-marken-entdecken_alle-marken-entdecken',
    'uhren_alle-marken-entdecken_alle-marken-entdecken',
    'accessoires_alle-accessoires-entdecken_alle-accessoires-entdecken'
  ];
  $.each( aMenus, function( index, value ) {
    var lblParent = previousId( value, 0, 1);
    var lblFrom = previousId( value, 1, 99);
    var lblTo = previousId( value, 1, 2);
/*
    console.log( lblParent );
    console.log( lblFrom );
    console.log( lblTo );
    $("#"+value).insertBefore( "#"+ previousId( value, 1 ) );
    $("#"+ previousId( value, 1 ) ).hide();
*/
    var objFrom = $('li.sublink>ul>div[data-meganav-mobile][data-meganav-handle="'+lblParent+'"]').find("#"+lblFrom);
    var objTo = $('li.sublink>ul>div[data-meganav-mobile][data-meganav-handle="'+lblParent+'"]').find("#"+lblTo);
    objFrom.insertBefore( objTo );
    objTo.hide();
  });
  $('span:contains("hide")').each(function() {
    const li = $(this).closest('li');
    li.hide();
  });
  // Desplegar acordeones en móvil
  /*
  document.querySelector('#faqs>.iguana-section__head').click();
  document.querySelector('#envios>.iguana-section__head').click(); 
  */
  ['#faqs', '#envios'].forEach(function (id) {
    var sec = document.querySelector(id);
    sec.classList.add('is-open');
    sec.querySelector('[class$="__chev"]').textContent = '\u2212';
  });
});

// Sticky add to cart v1
    if (! window.PXUTheme.media_queries.large.matches) {
      if( $("body").hasClass("product") && $('#header').hasClass('mobile_nav-fixed--true') ) {
	    $("#sticky-plus-product-bar").addClass("underbar");
// Add event
        window.onscroll = function() {
          IguanaStickyFunction()
        };
      } else {
        window.removeEventListener('scroll', IguanaStickyFunction);
      }
	}

    function IguanaStickyFunction() {
      if( $(".purchase-details").length ) {
        var iguana_sticky = $(".purchase-details").offset().top;
        if (window.pageYOffset >= iguana_sticky) {
          $("#sticky-plus-product-bar").show();
        } else {
          $("#sticky-plus-product-bar").hide();
        }
      }
    }
// Flickity error troubleshoot
/*
window.onload = function(){
    window.dispatchEvent(new Event('resize'));
}
*/
document.addEventListener("DOMContentLoaded", function() {
    var hash = window.location.hash;
    if (hash) {
        var target = document.querySelector(hash);
        if ( target ) {
            var accordionButton = target.getElementsByTagName('button');
            if (accordionButton) {
                accordionButton[0].click(); // Simula el clic para abrir la sección
            }
        }
    }
});

/* Quitar sticky de iguana-nav */
const marker = document.querySelector('.recently-viewed-products__title');
const sticky = document.querySelector('.igu-navbar');

const observer = new IntersectionObserver(([entry]) => {
  if (entry.isIntersecting) {
    // El marker está en pantalla → ocultar sticky
    sticky.classList.add('is-nav-hidden');
  } else if (entry.boundingClientRect.top < 0) {
    // El marker ya quedó por encima del viewport (lo pasamos) → seguir oculto
    sticky.classList.add('is-nav-hidden');
  } else {
    // El marker todavía no ha llegado (está más abajo) → mostrar sticky
    sticky.classList.remove('is-nav-hidden');
  }
}, { threshold: 0 });

observer.observe(marker);

/*

  document.addEventListener('DOMContentLoaded', function () {
    function waitForJudgeMeContent() {
      const reviewWidget = document.querySelector('.jdgm-widget.jdgm-review-widget');
      const carousel = document.querySelector('.jdgm-carousel');
      const carouselHeader = document.querySelector('.jdgm-carousel-title-and-link');
      const carouselWrapper = document.querySelector('.jdgm-carousel-wrapper');

      if (!reviewWidget || !carousel || !carouselWrapper) {
        requestAnimationFrame(waitForJudgeMeContent);
        return;
      }

      const observer = new MutationObserver(() => {
        const hasReviews = reviewWidget.querySelectorAll('.jdgm-rev').length > 0;

        if (hasReviews) {
          // Ocultamos todo: carousel, header y contenedor
          carouselWrapper.style.display = 'none';
        } else {
          carouselWrapper.style.display = 'block';
        }

        observer.disconnect();
      });

      observer.observe(reviewWidget, { childList: true, subtree: true });
    }

    waitForJudgeMeContent();
  });
*/

/* Redirección personalizada de filtros de marca en colecciones macro. 
     Fecha: Abril 2025
     Descripción: Cuando un usuario selecciona una marca desde los filtros de 'relojes', 'escritura',
     'encendedores' o 'accesorios', redirige a la colección de la marca con el filtro aplicado. */
/*     
document.addEventListener('DOMContentLoaded', function () {
  const allowedCollections = ['relojes', 'escritura', 'encendedores', 'accesorios'];
  const brandRedirects = {
    's-t-dupont': 'st-dupont',
    'a-lange-sohne': 'a-lange-and-sohne',
    'carl-f-bucherer': 'carl-f-bucherer',
    'jaeger-lecoultre': 'jaeger-lecoultre',
    // Añade más excepciones si es necesario
  };

  const getCurrentCollectionHandle = () => {
    const path = window.location.pathname;
    const match = path.match(/^\/collections\/([^\/\?]+)/);
    return match ? match[1] : null;
  };

  const redirectIfSingleVendorFilter = () => {
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;
    const vendors = searchParams.getAll('filter.p.vendor');
    const currentCollection = getCurrentCollectionHandle();

    if (vendors.length === 1 && allowedCollections.includes(currentCollection)) {
      const vendor = vendors[0];
      let handle = vendor
        .toLowerCase()
        .replace(/[\s&]+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-+/g, '-');

      if (brandRedirects[handle]) {
        handle = brandRedirects[handle];
      }

      // Crear nuevos parámetros sin el vendor actual
      const newParams = new URLSearchParams();

      for (const [key, value] of searchParams.entries()) {
        if (!(key === 'filter.p.vendor')) {
          newParams.append(key, value);
        }
      }

      // Agregar el único vendor filtrado
      newParams.append('filter.p.vendor', vendor);

      const targetUrl = `/collections/${handle}?${newParams.toString()}`;

      if (window.location.pathname !== `/collections/${handle}`) {
        window.location.href = targetUrl;
      }
    }
  };

  redirectIfSingleVendorFilter();
});
*/
